<template>
    <div class="row">
        <div class="col-md-12 d-flex justify-content-between">
            <h1 class="h3 mb-3 text-gray-800">
                {{ $t("Relatórios da Equipe SUAS") }}
            </h1>

            <b-dropdown
                no-caret
                variant="primary"
                size="sm"
                v-b-tooltip.hover
                right
                title="Menu de Relatórios da Equipe SUAS"
            >
                <template #button-content>
                    Menu
                    <i class="fas fa-bars"></i>
                </template>
                <b-dropdown-group
                    id="dropdown-group-1"
                    header="Relatórios da Equipe SUAS"
                >
                    <b-dropdown-item
                        :to="'/dashboard/relatorios/tecnicos/home'"
                        :disabled="$route.name == 'relatorios_home_tecnicos'"
                    >
                        Todos os Técnicos
                    </b-dropdown-item>
                    <b-dropdown-item
                        :to="'/dashboard/relatorios/tecnicos/graficos'"
                        :disabled="$route.name == 'graficos_tecnicos'"
                    >
                        Gráficos de Equipe SUAS
                    </b-dropdown-item>
                </b-dropdown-group>
            </b-dropdown>
        </div>
        <div class="col-md-12">
            <load v-if="loading" />
            <router-view v-else />
        </div>
    </div>
</template>
<script>
export default {
    name: "ReportsTecnicos",
    metaInfo() {
        return {
            title: this.$i18n.t("Relatórios da Equipe SUAS"),
        };
    },
    mounted() {},
    data() {
        return {
            loading: false,
        };
    },
    methods: {},
};
</script>
